<template>
  <div class="skin-evaluation" v-if="!isEmpty">
    <div class="title"><img class="icon" src="@/assets/zs_imgs/skin-evalution-title-icon.png" alt="" /> 服装评测</div>
    <div class="skin-list">
      <template v-for="key in Object.keys(dataSource)">
        <a
          class="item"
          :key="key + dataSource[key].evaluation.cover.value"
          :href="dataSource[key].evaluation.link.value"
          target="_self"
          v-if="
            dataSource[key].evaluation.cover.hasValue &&
              dataSource[key].evaluation.title.hasValue &&
              dataSource[key].evaluation.cover.value &&
              dataSource[key].evaluation.title.value
          "
        >
          <img class="icon" alt="" :src="dataSource[key].evaluation.cover.value" />
          <div class="name">
            {{ dataSource[key].evaluation.title.value }}
          </div>
        </a>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    isEmpty() {
      const flag = !Object.keys(this.dataSource).some(key => {
        return (
          this.dataSource[key].evaluation.cover.hasValue &&
          this.dataSource[key].evaluation.title.hasValue &&
          this.dataSource[key].evaluation.cover.value &&
          this.dataSource[key].evaluation.title.value
        );
      });
      return flag;
    }
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.skin-evaluation {
  width: 100%;
  padding: 10px 0;
  // background: #18171e;
  & > .title {
    position: relative;
    width: 160px;
    height: 20px;
    background: linear-gradient(90deg, rgba(34, 82, 100, 0.87) 21%, rgba(34, 82, 100, 0) 100%);
    font-weight: 400;
    font-size: 15px;
    color: #ffffff;
    margin-bottom: 18px;
    margin-left: 10px;
    padding-left: 16px;
    &::before {
      content: "";
      display: inline-block;
      width: 32px;
      height: 32px;
      background: url("~@/assets/zs_imgs/skill-more-title-bg-icon.png") no-repeat;
      background-size: cover;
      position: absolute;
      left: -16px;
      top: -6px;
    }
    .icon {
      position: absolute;
      left: -12px;
      top: -3px;
      width: 24px;
      height: 24px;
      vertical-align: middle;
    }
  }

  .skin-list {
    display: flex;
    align-items: center;
    gap: 22px;
    overflow-x: auto;
    overflow-y: hidden;
    /* 滚动槽 */
    &::-webkit-scrollbar {
      width: 4px;
      height: 5px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 2px;
      background: rgba(255, 255, 255, 0.1);
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.08);
    }
    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: #95cde7;
      -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    }
    .item {
      flex-shrink: 0;
      position: relative;
      width: 153px;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .icon {
        width: 153px;
        height: 90px;
        object-fit: cover;
        margin-bottom: 10px;
        border-radius: 4px;
      }

      .name {
        width: 100%;
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 15px;
        color: #d4d4d4;
        line-height: 23px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
}
</style>
